import { CustomerRepresentativeFiltersFormValues } from './types';

export const defaultFilters: CustomerRepresentativeFiltersFormValues = {
  initiators: [],
};

export const defaultSkipCount = 0;
export const defaultMaxResultCount = 15;
